/// <reference path="koyori.ts" />

/**
 * コンポーネントをグループ化します。
 * <dl>
 * <dt>属性</dt>
 * </dl>
 */
class KoyoriGroup extends KoyoriElement {

}
window.customElements.define('koy-group', KoyoriGroup);